import { Component, inject, Input } from '@angular/core';
import { AddPodcastFeed } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'rk-add-podcast-button',
  standalone: false,
  templateUrl: './add-podcast-button.component.html',
  styleUrl: './add-podcast-button.component.scss',
})
export class AddPodcastButtonComponent {
  private readonly store = inject(Store);
  @Input() podcastFeedListLength: number;

  onAddNewPodcast() {
    const pageIndex = this.store.selectSnapshot(AppConfigurationState.activePageIndex);
    this.store.dispatch(
      new AddPodcastFeed('', pageIndex, this.podcastFeedListLength + 1),
    );
  }
}
